module.exports = __webpack_public_path__ + "media/images/top/qa/ranking_banner03-fb99e4b7edfb368477ae8c33cc057e1f.png";